export const deviceTypes = {
    mobile: 1,
    tablet: 2,
    columns2: 3,
    columns3: 4,
    columns4: 5,
}